import { ReactNode } from 'react';
import styled from 'styled-components';
import { Box, SmallSectionHeading } from '@99designs/emu';
import { breakpoints, spaces } from '@99designs/emu/settings';

export const TwoColumnLayoutHeader = styled.div`
    padding-right: ${spaces['1bu']};

    @media (min-width: ${breakpoints.small[0]}px) and (max-width: ${breakpoints.medium[1]}px) {
        padding-right: 0;
        margin-bottom: ${spaces['0.75bu']};
    }
`;

export const TwoColumnLayoutBody = styled.div``;

export const TwoColumnLayoutBox = styled(Box)`
    grid-template-columns: 1fr 2fr;
    grid-column-gap: ${spaces['1bu']};

    @media (min-width: ${breakpoints.small[0]}px) and (max-width: ${breakpoints.medium[1]}px) {
        grid-template-columns: 1fr;
        grid-column-gap: 0;
    }
`;

export default function TwoColumnLayout({ children }: { children: ReactNode }) {
    return (
        <TwoColumnLayoutBox display="grid" marginBottom="2bu">
            {children}
        </TwoColumnLayoutBox>
    );
}

export function TwoColumnLayoutHeading({ children }: { children: ReactNode }) {
    return <SmallSectionHeading>{children}</SmallSectionHeading>;
}
